import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export type Severity = 'high' | 'medium' | 'low';

export interface NextAction {
  key: string;
  severity: Severity;
  count: number;
  linkPath: string;
}

export interface NextActionsResponse {
  headcount: number;
  actions: NextAction[];
}

/** Ranked "next best action" feed for the home page (cohesion spine). */
export function useNextActions() {
  return useQuery({
    queryKey: ['dashboard', 'next-actions'],
    queryFn: async () => (await api.get<NextActionsResponse>('/api/dashboard/next-actions')).data,
    staleTime: 30_000,
  });
}
